"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaceOfBirthProperty = exports.placeOfBirthPropertyDefinition = void 0;
exports.placeOfBirthPropertyDefinition = {
    view: {
        label: 'Place of birth',
        hint: 'Format: City, Country',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 55,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'place-of-birth',
};
const isPlaceOfBirthProperty = (prop) => {
    return prop.name === exports.placeOfBirthPropertyDefinition.name;
};
exports.isPlaceOfBirthProperty = isPlaceOfBirthProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhY2Utb2YtYmlydGgucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wbGFjZS1vZi1iaXJ0aC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsSUFBSSxFQUFFLHVCQUF1QjtLQUU5QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxnQkFBZ0I7Q0FDUyxDQUFBO0FBSTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=